import React, { useState, useEffect, useRef } from "react";
import { ThemeCtx, ToastCtx, api, SEV_C, STAT_C, PAGE_SIZE, Pager, Card, Modal, Bdg, Dot, Av, AdminBadge, useToast, ConfirmDialog, usePagination } from "../shared.js";

export function PageChangePass({user}){
  var T=React.useContext(ThemeCtx).T;
  var _cur=useState(""); var cur=_cur[0]; var setCur=_cur[1];
  var _new1=useState(""); var new1=_new1[0]; var setNew1=_new1[1];
  var _new2=useState(""); var new2=_new2[0]; var setNew2=_new2[1];
  var _msg=useState({text:"",type:""}); var msg=_msg[0]; var setMsg=_msg[1];
  var _saving=useState(false); var saving=_saving[0]; var setSaving=_saving[1];
  var showMsg=function(text,type){setMsg({text,type});setTimeout(function(){setMsg({text:"",type:""});},5000);};
  var iStyle={width:"100%",padding:"10px 12px",background:T.inset,border:"1px solid "+T.border,color:T.text,fontSize:13,outline:"none",boxSizing:"border-box"};
  var lStyle={fontSize:11,color:T.text3,marginBottom:4,textTransform:"uppercase",letterSpacing:.5,display:"block"};

  var submit=async function(){
    if(!cur){showMsg("Enter current password","error");return;}
    if(new1.length<8){showMsg("New password must be at least 8 characters","error");return;}
    if(new1!==new2){showMsg("New passwords do not match","error");return;}
    setSaving(true);
    try{
      // Verify current password by attempting login
      await api.post("/auth/login",{username:user.username,password:cur});
      // Reset via admin endpoint or self-service
      await api.post("/users/"+user.id+"/reset-password",{new_password:new1});
      showMsg("Password changed successfully. Please log in again.","success");
      setCur("");setNew1("");setNew2("");
      setTimeout(function(){api.clearTokens();window.location.reload();},2000);
    }catch(e){showMsg(e.message||"Failed to change password","error");}
    setSaving(false);
  };

  return React.createElement("div",{style:{maxWidth:420}},
    React.createElement(Card,null,
      React.createElement("div",{style:{fontSize:15,fontWeight:600,color:T.text,marginBottom:16}},"Change Password"),
      msg.text&&React.createElement("div",{style:{background:msg.type==="success"?"#22c55e22":"#ef444422",border:"1px solid "+(msg.type==="success"?"#22c55e":"#ef4444")+"44",padding:"10px 12px",fontSize:13,color:msg.type==="success"?"#22c55e":"#ef4444",marginBottom:14}},msg.text),
      React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:12}},
        React.createElement("div",null,React.createElement("label",{style:lStyle},"Current Password"),React.createElement("input",{type:"password",value:cur,onChange:function(e){setCur(e.target.value);},style:iStyle})),
        React.createElement("div",null,React.createElement("label",{style:lStyle},"New Password (min 8 chars)"),React.createElement("input",{type:"password",value:new1,onChange:function(e){setNew1(e.target.value);},style:iStyle})),
        React.createElement("div",null,React.createElement("label",{style:lStyle},"Confirm New Password"),React.createElement("input",{type:"password",value:new2,onChange:function(e){setNew2(e.target.value);},onKeyDown:function(e){if(e.key==="Enter")submit();},style:iStyle})),
        new1&&new2&&new1!==new2&&React.createElement("div",{style:{fontSize:11,color:"#ef4444"}},"Passwords do not match"),
        new1&&new1.length>0&&new1.length<8&&React.createElement("div",{style:{fontSize:11,color:"#f97316"}},"Password too short (min 8 characters)"),
        React.createElement("button",{onClick:submit,disabled:saving,style:{background:"#A100FF",color:"#fff",border:"none",padding:"11px",cursor:"pointer",fontSize:13,fontWeight:700,letterSpacing:.5,opacity:saving?0.6:1,marginTop:4}},saving?"Changing...":"CHANGE PASSWORD >")
      )
    )
  );
}

